import { render, staticRenderFns } from "./ItemRandom.vue?vue&type=template&id=e5af79fa&scoped=true&"
import script from "./ItemRandom.vue?vue&type=script&lang=js&"
export * from "./ItemRandom.vue?vue&type=script&lang=js&"
import style0 from "./ItemRandom.vue?vue&type=style&index=0&id=e5af79fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5af79fa",
  null
  
)

export default component.exports